import { put, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import leadsSelectors from "rdx/modules/leads/selectors";
import projectSelectors from "rdx/modules/projects/selectors";
import platformSelectors from "rdx/modules/platform/selectors";
import { orgProjectsApi } from "rdx/modules/enterpriseProjects/endpoints";
import { ORG_PROJECTS_TAGS } from "rdx/modules/enterpriseProjects/tags";
import { camelizeKeys, formatPreSalesProject } from "lib/helpers";
import actions from "rdx/actions";
import messages from "../messages";

function* submitLeadToProvider(action) {
  const { leadId, enterprise, admin } = action.payload;
  if (!leadId) {
    throw new Error(`Invalid lead ID = ${leadId} specified. Please check this parameter.`);
  }
  const { success, data, error } = yield* makeRequest.post(`/provider_leads/${leadId}/qualify`, {
    lead_id: leadId,
    enterprise,
    admin,
  });

  if (success && data) {
    const existingLeadDetails = yield select(leadsSelectors.getLeadDetails);
    const existingProjectDetails = yield select(projectSelectors.getProjectDetails);

    const l2pLeadId = yield select(platformSelectors.selectLeadToProposalDrawerLeadId);
    const providerLead = camelizeKeys(data.body);
    if (l2pLeadId === leadId) {
      yield put(actions.setLeadToProposalDrawerProjectId({ id: data.body.id }));
      yield put(actions.setLeadToProposalDrawerProjectDetails(providerLead));
      yield put(actions.setLeadToProposalDrawerLeadQualified());
    }
    if (existingLeadDetails?.id === leadId || existingProjectDetails?.lead?.id === leadId) {
      yield put(actions.setProjectDetails({ providerLead }));
      yield put(actions.setLeadSubmitted());
    }
    yield put(orgProjectsApi.util.invalidateTags([ORG_PROJECTS_TAGS.ORG_PRE_SALES_PROJECTS]));
    yield put(actions.updatePreSalesProject(formatPreSalesProject(providerLead)));
    if (admin && existingLeadDetails?.id === leadId) {
      yield put(actions.setAdminProjectDetails(providerLead));
    }

    yield put(
      actions.newSuccessEvent({
        message: messages.LEAD_SUBMIT_SUCCESS,
        payload: data.body,
      }),
    );
  } else {
    return getErrorActions({ error, message: messages.ERROR_SUBMITTING_LEAD });
  }
  return null;
}

export default submitLeadToProvider;
